import { render } from "./LifeOSSection.vue?vue&type=template&id=f7f0e864&scoped=true"
import script from "./LifeOSSection.vue?vue&type=script&lang=js"
export * from "./LifeOSSection.vue?vue&type=script&lang=js"

import "./LifeOSSection.vue?vue&type=style&index=0&id=f7f0e864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f0e864"]])

export default __exports__